@if (groupLoading()) {
  <div class="cgd-loading"><i class="fa-solid fa-spinner fa-spin"></i></div>
} @else if (g) {
<div class="cgd-wrapper">

  <!-- Breadcrumb -->
  <nav class="cgd-breadcrumb">
    <a class="cgd-breadcrumb-btn" routerLink="/customer-groups" (click)="onBreadcrumbClick($event)">Customer Groups</a>
    <span class="cgd-breadcrumb-sep">/</span>
    <span class="cgd-breadcrumb-current">{{ g.name }}</span>
          <span class="cgd-status-chip" [class.inactive]="g.status === 'INACTIVE'">
            {{ g.status === 'ACTIVE' ? 'Active' : 'Inactive' }}
          </span>
  </nav>

  <!-- Header -->
  <div class="cgd-header">
    <div class="cgd-header-left">
      @if (g.badgeUrl) {
        <img class="cgd-header-badge" [src]="g.badgeUrl" alt="badge" />
      } @else {
        <div class="cgd-header-badge-placeholder" [style.background]="g.color + '22'" [style.border-color]="g.color + '44'">
          <span [style.color]="g.color">{{ g.name[0].toUpperCase() }}</span>
        </div>
      }
      <div class="cgd-header-info">
        <div class="cgd-title-row">
          <h2 class="cgd-title">{{ g.name }}</h2>
          <span class="cgd-header-dot" [style.background]="g.color"></span>
        </div>
        <div class="cgd-meta">
          @if (g.description) {
            <span class="cgd-desc">{{ g.description }}</span>
          }
        </div>
      </div>
    </div>
    <div class="cgd-header-right">
      <span class="cgd-member-count"><i class="fa-solid fa-users"></i> {{ membersTotal }} members</span>
      <span class="cgd-send-count"><i class="fa-solid fa-paper-plane"></i> {{ g.sendCount }} sent</span>
      <span class="cgd-discount-badge">
        @if (g.maxDiscountPercentage !== null && g.maxDiscountPercentage !== undefined) {
          <i class="fa-solid fa-tag"></i> Up to {{ g.maxDiscountPercentage }}%
        } @else {
          No discount
        }
      </span>
      <div class="cgd-header-actions">
        <button class="cgd-action-icon-btn" (click)="openEdit()" title="Edit group">
          <i class="fa-solid fa-pen"></i>
        </button>
        <button class="cgd-action-icon-btn cgd-action-icon-btn--danger" (click)="confirmDelete = true" title="Delete group">
          <i class="fa-solid fa-trash"></i>
        </button>
      </div>
    </div>
  </div>

  <!-- Edit dialog -->
  <app-add-group-form
    [(visibility)]="editDialogVisible"
    [editGroup]="g"
    (saved)="onGroupUpdated()" />

  <!-- Delete confirm dialog -->
  <p-dialog
    header="Delete Group"
    [(visible)]="confirmDelete"
    [modal]="true" [closable]="true" [draggable]="false" [resizable]="false"
    styleClass="cgd-confirm-dialog">
    <p class="cgd-confirm-text">Are you sure you want to delete <strong>{{ g.name }}</strong>? This cannot be undone.</p>
    <ng-template pTemplate="footer">
      <button class="cgd-dialog-cancel-btn" (click)="confirmDelete = false">Cancel</button>
      <button class="cgd-dialog-delete-btn" (click)="deleteGroup()" [disabled]="deleting()">
        @if (deleting()) { <i class="fa-solid fa-spinner fa-spin"></i> Deleting… }
        @else { <i class="fa-solid fa-trash"></i> Delete }
      </button>
    </ng-template>
  </p-dialog>

  <!-- Remove member / plan discount confirm dialog -->
  <p-dialog
    [header]="pendingRemoval?.kind === 'member' ? 'Remove Member' : 'Remove Plan Discount'"
    [(visible)]="confirmRemoveVisible"
    [modal]="true" [closable]="true" [draggable]="false" [resizable]="false"
    styleClass="cgd-confirm-dialog"
    (onHide)="pendingRemoval = null">
    @if (pendingRemoval) {
      <p class="cgd-confirm-text">
        @if (pendingRemoval.kind === 'member') {
          Are you sure you want to remove <strong>{{ pendingRemoval.name }}</strong> from <strong>{{ g.name }}</strong>?
        } @else {
          Are you sure you want to remove the discount for <strong>{{ pendingRemoval.name }}</strong>?
        }
      </p>
    }
    <ng-template pTemplate="footer">
      <button class="cgd-dialog-cancel-btn" (click)="cancelRemoval()">Cancel</button>
      <button class="cgd-dialog-delete-btn" (click)="confirmRemoval()">
        <i class="fa-solid fa-trash"></i> Remove
      </button>
    </ng-template>
  </p-dialog>

  <!-- Tab bar -->
  <div class="cgd-tab-bar">
    <button class="cgd-tab" [class.active]="activeTab === 'members'" (click)="activeTab = 'members'">
      <i class="fa-solid fa-users"></i> Members
    </button>
    <button class="cgd-tab" [class.active]="activeTab === 'discounts'" (click)="activeTab = 'discounts'">
      <i class="fa-solid fa-tag"></i> Plan Discounts
    </button>
  </div>

  <!-- ── Members tab ── -->
  @if (activeTab === 'members') {
  <div class="cgd-members-tab">

    <!-- Toolbar -->
    <div class="cgd-members-toolbar">
      <div class="cgd-search">
        <i class="fa-solid fa-magnifying-glass"></i>
        <input type="text" [ngModel]="memberSearch" (ngModelChange)="onMemberSearch($event)" placeholder="Search members..." />
      </div>
      <button class="cgd-add-member-btn" (click)="showAddMemberDialog = true">
        <i class="fa-solid fa-plus"></i> Add customer
      </button>
    </div>

    @if (membersLoading() && members().length === 0) {
      <div class="cgd-loading"><i class="fa-solid fa-spinner fa-spin"></i></div>
    } @else if (members().length === 0) {
      <div class="cgd-empty">No members yet.</div>
    } @else {
      <div class="cgd-member-list">
        @for (m of members(); track m.id) {
        <a class="cgd-member-row" [routerLink]="['/customers', m.id]" (click)="onMemberClick($event, m.id)" (keydown.enter)="openCustomer(m.id)">
          <div class="cgd-avatar">{{ initials(m) }}</div>
          <div class="cgd-member-info">
            <span class="cgd-member-name">{{ fullName(m) }}</span>
            <span class="cgd-member-email">{{ m.email }}</span>
            @if (m.phoneNumber) {
              <span class="cgd-member-phone">{{ m.phoneNumber }}</span>
            }
          </div>
          <span class="cgd-member-status" [style]="statusStyle(m.status)">{{ getStatus(m.status) }}</span>
          @if (m.hasFcmToken) {
            <span class="cgd-fcm-badge" title="Has push notifications"><i class="fa-solid fa-bell"></i></span>
          }
          <button class="cgd-remove-btn" (click)="askRemoveMember(m); $event.stopPropagation(); $event.preventDefault()"
            [disabled]="mutating()" title="Remove from group">
            @if (mutating()) { <i class="fa-solid fa-spinner fa-spin"></i> }
            @else { <i class="fa-solid fa-xmark"></i> }
          </button>
        </a>
        }
        @if (membersHasNext) {
        <button class="cgd-load-more" (click)="loadMoreMembers()" [disabled]="membersLoading()">
          @if (membersLoading()) { <i class="fa-solid fa-spinner fa-spin"></i> } @else { Load more }
        </button>
        }
      </div>
    }

    <!-- Add customer dialog -->
    <p-dialog
      header="Add Customer"
      [(visible)]="showAddMemberDialog"
      [modal]="true"
      [closable]="true"
      [draggable]="false"
      [resizable]="false"
      styleClass="cgd-add-member-dialog"
      (onHide)="closeAddMemberDialog()">

      <div class="cgd-dialog-body">
        <div class="cgd-search cgd-dialog-search">
          <i class="fa-solid fa-magnifying-glass"></i>
          <input type="text" [ngModel]="addSearch" (ngModelChange)="onAddSearch($event)" placeholder="Search customers..." />
        </div>

        @if (addLoading && addOptions.length === 0) {
          <div class="cgd-loading" style="padding:24px"><i class="fa-solid fa-spinner fa-spin"></i></div>
        } @else if (addSearch && addOptions.length === 0 && !addLoading) {
          <div class="cgd-empty">No customers found.</div>
        } @else if (!addSearch) {
          <div class="cgd-empty" style="padding:24px 0">Search for a customer to add.</div>
        } @else {
          <div class="cgd-add-list">
            @for (opt of addOptions; track opt.value) {
            <div class="cgd-add-row" [class.cgd-add-row--selected]="selectedCustomerIds.has(opt.value)"
              role="button" tabindex="0" (click)="toggleSelectCustomer(opt.value)" (keydown.enter)="toggleSelectCustomer(opt.value)">
              <div class="cgd-avatar">{{ opt.initials }}</div>
              <div class="cgd-member-info">
                <span class="cgd-member-name">{{ opt.label }}</span>
                <span class="cgd-member-email">{{ opt.email }}</span>
              </div>
              <span class="cgd-member-status" [style]="statusStyle(opt.status)">{{ getStatus(opt.status) }}</span>
              <div class="cgd-select-check">
                @if (selectedCustomerIds.has(opt.value)) {
                  <i class="fa-solid fa-check"></i>
                } @else {
                  <i class="fa-solid fa-plus"></i>
                }
              </div>
            </div>
            }
          </div>
        }
      </div>

      <ng-template pTemplate="footer">
        @if (selectedCustomerIds.size > 0) {
          <span class="cgd-selected-count">{{ selectedCustomerIds.size }} selected</span>
        }
        <button class="cgd-dialog-cancel-btn" (click)="closeAddMemberDialog()">Close</button>
        <button class="cgd-dialog-save-btn" (click)="saveSelectedCustomers()"
          [disabled]="!selectedCustomerIds.size || mutating()">
          @if (mutating()) { <i class="fa-solid fa-spinner fa-spin"></i> Adding… }
          @else { <i class="fa-solid fa-user-plus"></i> Add ({{ selectedCustomerIds.size }}) }
        </button>
      </ng-template>
    </p-dialog>

  </div>
  }

  <!-- ── Discounts tab ── -->
  @if (activeTab === 'discounts') {
  <div class="cgd-discounts">

    <!-- Toolbar -->
    <div class="cgd-discounts-toolbar">
      <button class="cgd-add-discount-btn" (click)="openAddRow()">
        <i class="fa-solid fa-plus"></i> Add plan discount
      </button>
    </div>

    <!-- Add discount dialog -->
    <p-dialog
      header="Add Plan Discount"
      [(visible)]="showAddRow"
      [modal]="true"
      [closable]="true"
      [draggable]="false"
      [resizable]="false"
      styleClass="cgd-discount-dialog"
      (onHide)="cancelAddRow()">

      <div class="cgd-dialog-body">
        <div class="cgd-dialog-field">
          <span class="cgd-dialog-label">Plan</span>
          <p-select
            [options]="availablePlansFiltered"
            [(ngModel)]="newPlan"
            optionLabel="name"
            placeholder="Select a plan…"
            [loading]="plansLoading"
            appendTo="body"
            (onChange)="onPlanSelect($event.value)"
            styleClass="cgd-plan-select w-full" />
        </div>

        @if (newPlanLoading) {
          <div style="display:flex;justify-content:center;padding:24px">
            <i class="fa-solid fa-spinner fa-spin" style="font-size:20px;color:var(--primary-color)"></i>
          </div>
        } @else if (newPlanDetails) {
          <div class="cgd-dialog-preview">
            <div class="cgd-preview-row">
              <span class="cgd-preview-label">Base price</span>
              <span class="cgd-preview-value">{{ newPlanDetails.basePrice | number:'1.2-2' }} AED</span>
            </div>
            <div class="cgd-preview-row">
              <span class="cgd-preview-label">Plan discount</span>
              <span class="cgd-preview-value">{{ newPlanDetails.discountPercentage | number:'1.0-0' }} %</span>
            </div>
            <div class="cgd-preview-row">
              <span class="cgd-preview-label">Plan final price</span>
              <span class="cgd-preview-value">{{ newPlanDetails.finalPrice | number:'1.2-2' }} AED</span>
            </div>
            <div class="cgd-preview-row">
              <span class="cgd-preview-label">Duration</span>
              <span class="cgd-preview-value">{{ newPlanDetails.duration }} {{ newPlanDetails.durationUnit }}</span>
            </div>
            <div class="cgd-preview-row">
              <span class="cgd-preview-label">Included km</span>
              <span class="cgd-preview-value">{{ newPlanDetails.includedKilometers | number }} km</span>
            </div>
            <div class="cgd-preview-row">
              <span class="cgd-preview-label">Group discount %</span>
              <div class="cgd-number-input-wrap">
                <input
                  type="number"
                  class="cgd-number-input"
                  [value]="newDiscountPct"
                  min="1" max="100" step="1"
                  (input)="onDiscountInput($event)" />
                <span class="cgd-number-suffix">%</span>
              </div>
            </div>
            <div class="cgd-preview-row cgd-preview-row--final">
              <span class="cgd-preview-label">Group final price</span>
              <span class="cgd-preview-value cgd-preview-final">{{ newFinalPrice | number:'1.2-2' }} AED</span>
            </div>
          </div>
        }
      </div>

      <ng-template pTemplate="footer">
        <button class="cgd-dialog-cancel-btn" (click)="cancelAddRow()">
          Cancel
        </button>
        <button class="cgd-dialog-save-btn" (click)="confirmAddRow()" [disabled]="!newPlanDetails || newPlanLoading">
          <i class="fa-solid fa-plus"></i> Save discount
        </button>
      </ng-template>
    </p-dialog>

    @if (discounts.length === 0 && !showAddRow) {
      <div class="cgd-empty cgd-discounts-empty">No plan discounts configured.</div>
    } @else if (discounts.length > 0) {
      <div class="cgd-discount-list">
        <div class="cgd-discount-header-row">
          <span>Plan</span>
          <span>Base price</span>
          <span>Plan discount</span>
          <span>Plan final price</span>
          <span>Duration</span>
          <span>Included km</span>
          <span>Group discount</span>
          <span>Group final price</span>
          <span></span>
        </div>
        @for (d of discounts; track d.planId) {
        <div class="cgd-discount-row" [class.inactive-plan]="!d.planActive">
          <span class="cgd-discount-plan">
            {{ d.planName }}
            @if (!d.planActive) { <span class="cgd-plan-inactive-chip">Inactive</span> }
          </span>
          <span class="cgd-discount-cell" data-label="Base price">
            @if (d.plan) { {{ d.plan.basePrice | number:'1.2-2' }} AED } @else { — }
          </span>
          <span class="cgd-discount-cell" data-label="Plan discount">
            @if (d.plan) { {{ d.plan.discountPercentage | number:'1.0-0' }}% } @else { — }
          </span>
          <span class="cgd-discount-cell" data-label="Plan final price">
            @if (d.plan) { {{ d.plan.finalPrice | number:'1.2-2' }} AED } @else { — }
          </span>
          <span class="cgd-discount-cell" data-label="Duration">
            @if (d.plan) { {{ d.plan.duration }} {{ d.plan.durationUnit }} } @else { — }
          </span>
          <span class="cgd-discount-cell" data-label="Included km">
            @if (d.plan) { {{ d.plan.includedKilometers | number }} km } @else { — }
          </span>
          <span class="cgd-discount-display" data-label="Group discount">{{ d.discountPercentage | number:'1.0-0' }}%</span>
          <span class="cgd-discount-final" data-label="Group final price">
            @if (discountFinalPrice(d) !== null && discountFinalPrice(d) !== undefined) { {{ discountFinalPrice(d) | number:'1.2-2' }} AED }
            @else { — }
          </span>
          <button class="cgd-remove-discount-btn" (click)="askRemoveDiscount(d)"
            title="Remove discount" [disabled]="discountsSaving()">
            <i class="fa-solid fa-trash"></i>
          </button>
        </div>
        }
      </div>
    }

    @if (discountsSaving()) {
    <div class="cgd-discounts-footer">
      <span class="cgd-saving-indicator"><i class="fa-solid fa-spinner fa-spin"></i> Saving…</span>
    </div>
    }

  </div>
  }


</div>
}
